module.exports = __webpack_public_path__ + "static/img/129_TO8_1681_og.8bf5ed3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/129_TO8_1681_og.jpg
// module id = cl5b
// module chunks = 0